var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinterLadderMRDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 116,
    viewBox: "0 0 129 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.96 93.0694L121.421 94.7475L95.7684 110.359L95.4194 108.493L121.328 92.6025L122.96 93.0694Z",
    fill: "#B48648"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7945 109.24L122.96 93.0695L120.722 91.0169L94.2774 106.931L96.7945 109.24Z",
    fill: "#9F753F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7948 109.24L95.7686 110.359L93.2514 108.05L94.2777 106.931L96.7948 109.24Z",
    fill: "#936C3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.799 81.6881L111.259 83.3662L85.6073 98.9774L85.2582 97.1121L111.167 81.2212L112.799 81.6881Z",
    fill: "#B48648"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6331 97.8587L112.799 81.688L110.561 79.6355L84.116 95.5495L86.6331 97.8587Z",
    fill: "#9F753F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6335 97.8587L85.6072 98.9774L83.09 96.6683L84.1163 95.5496L86.6335 97.8587Z",
    fill: "#936C3A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.106 72.774L99.5661 74.4521L73.9139 90.0634L73.5649 88.1981L99.4737 72.3071L101.106 72.774Z",
    fill: "#B48648"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9395 88.9447L101.105 72.7741L98.8675 70.7215L72.4224 86.6356L74.9395 88.9447Z",
    fill: "#9F753F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9396 88.9449L73.9133 90.0636L71.3962 87.7545L72.4225 86.6358L74.9396 88.9449Z",
    fill: "#936C3A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7663 62.7215L89.157 64.3355L62.8778 78.8617L62.6062 76.985L89.1557 62.1866L90.7663 62.7215Z",
    fill: "#B48648"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9457 77.787L90.7658 62.7217L88.6158 60.5795L61.5289 75.3742L63.9457 77.787Z",
    fill: "#9F753F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9321 77.793L62.8601 78.8679L60.4415 76.4558L61.5135 75.3809L63.9321 77.793Z",
    fill: "#936C3A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6684 53.8144L78.629 55.1111L48.0265 64.0644L48.1816 62.0537L79.1241 52.887L80.6684 53.8144Z",
    fill: "#B48648"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3857 63.2001L80.668 53.8146L78.9362 51.0929L47.4405 60.1384L49.3857 63.2001Z",
    fill: "#9F753F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3986 63.1968L48.0374 64.0623L46.0906 61.0003L47.4518 60.1349L49.3986 63.1968Z",
    fill: "#936C3A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8638 39.9657L64.3244 41.6438L38.6722 57.255L38.3232 55.3897L64.232 39.4988L65.8638 39.9657Z",
    fill: "#B48648"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6986 56.1362L65.8639 39.9656L63.6265 37.9131L37.1814 53.8271L39.6986 56.1362Z",
    fill: "#9F753F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6984 56.1364L38.6721 57.2551L36.155 54.946L37.1813 53.8273L39.6984 56.1364Z",
    fill: "#936C3A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4462 28.92L54.0184 30.6953L29.4504 47.9656L28.979 46.1271L53.7868 28.5617L55.4462 28.92Z",
    fill: "#B48648"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4016 46.7831L55.4464 28.92L53.0758 27.0183L27.7387 44.6441L30.4016 46.7831Z",
    fill: "#9F753F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4527 47.9719L26.7888 45.8337L27.7391 44.6498L30.403 46.7879L29.4527 47.9719Z",
    fill: "#936C3A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2266 21.2698L42.5723 22.8373L15.8786 36.597L15.663 34.7098L42.6302 20.6912L44.2266 21.2698Z",
    fill: "#B48648"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9806 35.553L44.2266 21.2699L42.1384 19.0658L14.6361 33.0726L16.9806 35.553Z",
    fill: "#9F753F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9816 35.5502L15.8789 36.5936L13.5311 34.1125L14.6339 33.069L16.9816 35.5502Z",
    fill: "#936C3A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7863 12.0897L33.0274 13.5355L5.4349 25.3891L5.35309 23.4908L33.2362 11.399L34.7863 12.0897Z",
    fill: "#B48648"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60764 24.425L34.7864 12.0895L32.8587 9.74423L4.44153 21.7838L6.60764 24.425Z",
    fill: "#9F753F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58576 24.4313L5.4126 25.3949L3.24455 22.7553L4.41771 21.7917L6.58576 24.4313Z",
    fill: "#936C3A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M125.917 105.567L18.7985 7.30113L22.016 7.16246L128.854 105.172L125.917 105.567Z",
    fill: "#A3754B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M125.916 105.567L124.377 107.245L18.0287 8.14045L18.7984 7.30141L125.916 105.567Z",
    fill: "#BB8F5B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M124.377 107.245L127.828 106.291L128.854 105.172L125.916 105.567L124.377 107.245Z",
    fill: "#936A44"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M109.85 112.975L112.485 111.787L5.36672 13.5212L2.45201 14.4527L109.85 112.975Z",
    fill: "#A3754B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M109.849 112.975L108.053 114.933L0.655795 16.4105L2.45178 14.4528L109.849 112.975Z",
    fill: "#BB8F5B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M112.485 111.787L110.945 113.465L108.054 114.933L109.85 112.975L112.485 111.787Z",
    fill: "#936A44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinterLadderMRDefault);
export default __webpack_public_path__ + "static/media/winter_ladder_m_r_default.21adb9ce392c1a7bedcb09c373a8e55b.svg";
export { ForwardRef as ReactComponent };